import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { getErrorMessage } from '../../utils/errorHandler';
import offlineImponiblesAPI, {
  SearchedImponible,
  SearchImponiblePayload,
} from './offlineImponibleAPI';

interface ImponiblesState {
  status: 'loading' | 'idle' | 'error' | 'success';
  error?: string;
  imponible?: SearchedImponible;
}

export const initialState: ImponiblesState = {
  status: 'idle',
};

export const searchImponible = createAsyncThunk<
  SearchedImponible,
  SearchImponiblePayload,
  { rejectValue: string }
>('imponible/buscar', async (data, thunkAPI) => {
  try {
    const response = await offlineImponiblesAPI.searchImponible(data);

    if (response.status === 'error') {
      return thunkAPI.rejectWithValue(response.error);
    }

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(getErrorMessage(err));
  }
});

export const OfflineImponiblesState = createSlice({
  name: 'OfflineImponiblesState',
  initialState,
  reducers: {
    cleanOfflineImponibleState(state) {
      state.status = 'idle';
      state.imponible;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(searchImponible.pending, state => {
        state.status = 'loading';
      })
      .addCase(searchImponible.fulfilled, (state, action) => {
        state.status = 'success';
        state.imponible = action.payload;
      })
      .addCase(searchImponible.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.payload;
      });
  },
});

export const offlineImponible = (state: RootState) =>
  state.offlineImponibles.imponible ?? undefined;
export const errorOfflineImponible = (state: RootState) =>
  state.offlineImponibles.error;
export const statusOfflineImponible = (state: RootState) =>
  state.offlineImponibles.status;

export const { cleanOfflineImponibleState } = OfflineImponiblesState.actions;

export default OfflineImponiblesState.reducer;
